"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _RadioGroup = require("../Radio/RadioGroup");
var _Popup = require("../Popup");
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Button = require("../Button");
var _Modal = require("../Modal/Modal");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var PopupOption = function PopupOption(props) {
  var _modalProps$footer, _modalProps$footer$bu, _props$popupProps3, _props$popupProps4;
  var popupProps = props.popupProps,
    radioGroupProps = props.radioGroupProps,
    multiRadioGroupProps = props.multiRadioGroupProps,
    footerProps = props.footerProps,
    showConfirm = props.showConfirm,
    modalProps = props.modalProps,
    customerElement = props.customerElement,
    groupClassName = props.groupClassName;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    modalActive = _useState2[0],
    setModalActive = _useState2[1];
  var onFooterClick = function onFooterClick() {
    var _footerProps$onClick;
    footerProps === null || footerProps === void 0 ? void 0 : (_footerProps$onClick = footerProps.onClick) === null || _footerProps$onClick === void 0 ? void 0 : _footerProps$onClick.call(footerProps);
    if (showConfirm) {
      setModalActive(true);
    }
  };
  var onModalClose = function onModalClose() {
    var _props$popupProps;
    setModalActive(false);
    (_props$popupProps = props.popupProps) === null || _props$popupProps === void 0 ? void 0 : _props$popupProps.onClose();
  };
  var modalFooter = modalProps !== null && modalProps !== void 0 && modalProps.footer ? _objectSpread(_objectSpread({}, modalProps === null || modalProps === void 0 ? void 0 : modalProps.footer), {}, {
    buttons: modalProps === null || modalProps === void 0 ? void 0 : (_modalProps$footer = modalProps.footer) === null || _modalProps$footer === void 0 ? void 0 : (_modalProps$footer$bu = _modalProps$footer.buttons) === null || _modalProps$footer$bu === void 0 ? void 0 : _modalProps$footer$bu.map(function (btn) {
      return _objectSpread(_objectSpread({}, btn), {}, {
        onClick: function onClick() {
          var _btn$onClick, _props$popupProps2;
          btn === null || btn === void 0 ? void 0 : (_btn$onClick = btn.onClick) === null || _btn$onClick === void 0 ? void 0 : _btn$onClick.call(btn);
          setModalActive(false);
          (_props$popupProps2 = props.popupProps) === null || _props$popupProps2 === void 0 ? void 0 : _props$popupProps2.onClose();
        }
      });
    })
  }) : undefined;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Popup.Popup, (0, _extends2.default)({}, popupProps, {
    showCloseIcon: true,
    className: (0, _clsx.default)((_props$popupProps3 = props.popupProps) === null || _props$popupProps3 === void 0 ? void 0 : _props$popupProps3.className),
    titleClassName: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('popup-option-title'), (_props$popupProps4 = props.popupProps) === null || _props$popupProps4 === void 0 ? void 0 : _props$popupProps4.titleClassName)
  }), customerElement ? customerElement : /*#__PURE__*/_react.default.createElement("div", null, radioGroupProps && /*#__PURE__*/_react.default.createElement(_RadioGroup.RadioGroup, (0, _extends2.default)({}, radioGroupProps, {
    options: radioGroupProps.options ? radioGroupProps.options.map(function (opt) {
      return _objectSpread(_objectSpread({}, opt), {}, {
        className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('popup-option-radio'), opt.className)
      });
    }) : []
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)(groupClassName)
  }, multiRadioGroupProps === null || multiRadioGroupProps === void 0 ? void 0 : multiRadioGroupProps.map(function (radioGroupProps) {
    return /*#__PURE__*/_react.default.createElement(_RadioGroup.RadioGroup, (0, _extends2.default)({
      key: radioGroupProps.options.toString()
    }, radioGroupProps, {
      options: radioGroupProps.options ? radioGroupProps.options.map(function (opt) {
        return _objectSpread(_objectSpread({}, opt), {}, {
          className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('popup-option-radio'), (0, _getPrefixCls.getPrefixCls)(opt.className))
        });
      }) : []
    }));
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({}, footerProps, {
    type: "primary",
    onClick: onFooterClick
  })))), /*#__PURE__*/_react.default.createElement(_Modal.Modal, (0, _extends2.default)({}, modalProps || {}, {
    active: modalActive,
    onClose: onModalClose,
    footer: modalFooter
  }), modalProps === null || modalProps === void 0 ? void 0 : modalProps.children));
};
exports.PopupOption = PopupOption;